<template>
	<div class="order-center">
		<div class="container">
			<div class="status-list">
				<div class="status-list-box">
					<div class="status-item" v-for="(v,k) in status_list" :key="`s`+k" :class="{active:form_data.status===k}" @click="change_status(k)">
						{{v.name}} <template v-if="v.count>0||true">({{v.count}})</template>
					</div>
				</div>
				<div class="filter-box">
					<div class="filter-item">
						<Poptip trigger="hover" placement="bottom">
							<template #content>
								<div class="cate-box">
									<div v-for="(item,index) in cate_list" :class="['item',{active:item.product_category_name === selected_cate}]" :key="index" @click="onCateClick(item)">{{ item.product_category_name }}</div>
								</div>
							</template>
							{{ selected_cate_display || '品类筛选' }}<Icon type="ios-arrow-down" />
						</Poptip>
					</div>
					<div class="filter-item">
						<Poptip trigger="hover" placement="bottom">
							<template #content>
								<div class="cate-box">
									<div v-for="(item,index) in orderby_list" :class="['item',{active:item.value === form_data.order_type}]" :key="index" @click="onOrderClick(item)">{{ item.name }}</div>
								</div>
							</template>
							{{ curr_order || '列表排序' }}<Icon type="ios-arrow-down" />
						</Poptip>
					</div>
					<div class="filter-item">
						<Poptip trigger="hover" placement="bottom">
							<template #content>
								<div class="cate-box">
									<div v-for="(item,index) in order_scale_list" :class="['item',{active:item.value === form_data.order_scale}]" :key="index" @click="onOrderScaleClick(item)">{{ item.name }}</div>
								</div>
							</template>
							{{ curr_order_scale || '订单规模' }}<Icon type="ios-arrow-down" />
						</Poptip>
					</div>
					<div class="search">
						<img src="../../assets/images/icon-search.png" alt="" class="icon-search">
						<input type="text" placeholder="搜索款式名称、订单号或款号" v-model="form_data.keyword" class="input" @keyup.enter="search">
					</div>
				</div>
			</div>

			<template v-if="display_order_list.length>0">
				<div class="list">
					<div class="item">
						<div class="th">
							<div class="info">产品信息</div>
							<div class="quantity">数量</div>
							<div class="amount">订单金额</div>
							<div class="status">订单状态</div>
							<div class="action">操作</div>
						</div>
					</div>
					<div class="item td" v-for="(v,k) in display_order_list"  :key="`or`+k" @click="go2detail(v.uuid)">
						<div class="title">
							<span class="order-tag" :class="v.quantity >= 10 ? 'tag-big' : 'tag-sample'">{{v.quantity >= 10 ? '大货' : '样衣'}}</span>
							订单号：{{v.order_no}}
						</div>
						<div class="content td">
							<div class="info" >
								<div v-for="(vv, kk) in v.mtms" class="sub-info" :key="`si`+kk">
									<div class="left">
										<img :src="vv.design_data.category.image|default_img(false)" alt="" class="image">
									</div>
									<div class="right">
										<div class="sub-name">名称：{{vv.design_data.category.name}}</div>
										<div class="sub-no">款号：{{vv.design_data.category.style_no}}</div>
										<div class="sub-category">分类：{{vv.design_data.category.product_category_name}}</div>
										<div class="sub-size">尺码：{{vv.spec_info.join('，')}}</div>
                    <div class="sub-category">性别：{{vv.design_data.category.pat && vv.design_data.category.pat.sex_text ? vv.design_data.category.pat.sex_text : '-'}}</div>
									</div>
								</div>
							</div>
							<div class="quantity">
								{{v.quantity}}
							</div>
							<div class="amount">
								￥{{v.total_price}}
							</div>
							<div class="status" :class="oc(v)">
								{{v.status_name}}
							</div>
							<div class="action">
								<div class="btn btn-pay" v-if="v.status_text === 'unpaid'" @click.stop="pay(v.uuid)">立即付款</div>
								<div class="btn btn-pay" v-if="v.need_makeup" @click.stop="makeup(v.uuid)">补差支付:￥{{ makeup }}</div>
								<div class="btn btn-pay" v-if="v.status_text === 'unpaid'" @click.stop="cancel(v.uuid)">取消订单</div>
                <div class="btn btn-pay" v-if="[1,3,5].includes(v.status)"  @click.stop="showChat(v)">取消订单</div>
								<div class="btn btn-pay" v-if="v.status_text === 'wait_confirm'" @click.stop="confirm(v.uuid)">确认收货</div>
								<div class="btn btn-pay" v-if="v.status_text === 'wait_delivery' && v.is_need_send_back && !v.self_send" @click.stop="onSubMeterials(v)">寄面辅料</div>
                <div class="btn btn-pay" v-if="v.status_text === 'complete' && !v.tax" @click.stop="onApplyTax(v)">申请开票</div>
                <div class="btn btn-pay" v-if="v.status_text === 'complete' && v.tax" @click.stop="onViewTax(v.tax)">{{v.tax.tax_file ? '查看发票' : '开票处理中'}}</div>
								<div class="btn-customer" @click.stop="showChat(v)">联系客服</div>
							</div>
						</div>

					</div>
				</div>
				<Page :current="page" :page-size="size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
			</template>
			<template v-else>
				<img src="../../assets/images/no-data.png" style="width:300px;display: block;margin:0 auto;" alt="">
			</template>

			<popup :show.sync="is_popup_show" width="650px" height="auto" @on-close="close">
				<h2>填写物流单号</h2>
				<div class="form" style="max-height:520px;overflow-y:auto;">
					<div class="form-group form-group-row" v-for="(item, index) in form_data_send.list" :key="index">
						<div class="form-label">快递名称：</div>
						<div class="form-control">
							<select class="input input-sm" placeholder="请输入快递名称" v-model="item.logistics_name" :disabled="item.is_entry" @change="onChangeLogistics(index)">
								<option
                v-for="(v, k) in logistics"
                :key="k"
                :value="v"
                >
                {{ v }}
              </option>
							</select>
						</div>
						<div class="form-label">快递单号：</div>
						<div class="form-control">
							<input type="text" class="input input-sm" placeholder="请输入快递单号" v-model="item.logistics_no" :readonly="item.is_entry" />
						</div>
						<div v-if="form_data_send.list.length > 1 && !item.is_entry" class="btn-delete" @click="removeLogistics(index)">删除</div>
					</div>
					<div class="btn-add" @click="addLogistics">+ 添加物流</div>
					<div class="btn-submit" @click="save">保存</div>
				</div>
			</popup>
      <popup :show.sync="show_tax_form" width="490px" :height="form_data_tax.type == '2' ?'650px' : '320px'" @on-close="closeTaxForm">
				<h2>申请开票</h2>
				<div class="form">
          <div class="form-group">
						<div class="form-label">开票类型：</div>
						<div class="form-control">
							<RadioGroup v-model="form_data_tax.type">
                <Radio :label="1">个人</Radio>
                <Radio :label="2">企业</Radio>
              </RadioGroup>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">发票抬头：</div>
						<div class="form-control">
							<input type="text" class="input" placeholder="请输入发票抬头" v-model="form_data_tax.title" />
						</div>
					</div>
          <template v-if="form_data_tax.type == 2">
            <div class="form-group">
              <div class="form-label">纳税人识别号：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入纳税人识别号" v-model="form_data_tax.tax_number" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">公司地址：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入公司地址" v-model="form_data_tax.company_address" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">电话：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入电话号码" v-model="form_data_tax.phone" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">开户行：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入开户行" v-model="form_data_tax.bank_name" />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">银行账号：</div>
              <div class="form-control">
                <input type="text" class="input" placeholder="请输入银行账号" v-model="form_data_tax.bank_account" />
              </div>
            </div>
          </template>
					<div class="btn-submit" @click="saveTax">保存</div>
				</div>
			</popup>
		
			<Chat ref="chat"></Chat>
		</div>
	</div>
</template>

<script>
import {
  CancelOrder,
  ConfirmOrder,
  OrderCount,
  OrderList,
  Profile,
  SendFabric, applyTax
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import logistics from "@/utils/logistics";
import axios from "axios";
const form_data_send = {
  logistics_name: "",
  logistics_no: "",
  uuid: "",
  list: [{ logistics_name: "", logistics_no: "", is_entry: false }],
};
export default {
  name: "OrderCenter",
  components: {
    Popup,
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: -1,
      form_data: {
        keyword: "",
        status: "all",
        order_type: "desc",
        order_scale: "",
      },
      status_list: {
        all: { name: "全部订单", value: "all", count: 0 },
        wait_pay: { name: "待付款", value: "wait_pay", count: 0 },
        wait_delivery: { name: "待发货", value: "wait_delivery", count: 0 },
        wait_confirm: { name: "待收货", value: "wait_confirm", count: 0 },
        complete: { name: "已完成", value: "complete", count: 0 },
        cancel: { name: "已取消", value: "cancel", count: 0 },
      },
      order_list: [],
      is_popup_show: false,
      form_data_send: { ...form_data_send },
      form_data_tax:{
        order_id:'',
        type:1,
        title:'',
        tax_number:'',
        company_address:'',
        phone:'',
        bank_name:'',
        bank_account:'',
      },
      show_tax_form:false,
      temp_order_no:'',
      logistics,
      selected_cate: "",
      selected_cate_display: "",
      curr_order: "最新订单",
      orderby_list: [
        { name: "最新订单", value: "desc", order: "desc" },
        { name: "最早订单", value: "asc", order: "asc" },
      ],
      curr_order_scale: "全部",
      order_scale_list: [
        { name: "全部", value: "" },
        { name: "大货订单", value: "big" },
        { name: "样衣订单", value: "sample" },
      ],
      all_cate_list: [],
    };
  },
  computed: {
    cate_list() {
      const cateList = this.all_cate_list.map(cate => ({
        product_category_name: cate
      }));
      return [{ product_category_name: "全部" }, ...cateList];
    },
    display_order_list() {
      return this.order_list;
    },
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
  },
  watch: {
    "form_data.status": function(newVal, oldVal) {
      this.form_data.status = newVal;
      this.page = 1;
      this.getOrderList();
    },
  },
  mounted() {
    this.change_status("all");
    axios
      .all([this.getProfile(), this.getOrderList()])
      .then(axios.spread(() => {}));
  },
  methods: {
    onChangeLogistics(index){
      const item = this.form_data_send.list[index];
      if(item.logistics_name === '送货上门'){
        item.logistics_no = this.temp_order_no;
      }
      console.log('form_data_send',this.form_data_send);
    },
    onViewTax({status,tax_file}){
      if(status == 1){
        this.$layer.msg('发票开具中.请耐心等待...');
        return;
      }
      if(!tax_file || !tax_file.startsWith('http')){
        this.$layer.msg('发票文件异常,请联系客服');
        return;
      }
      window.open(tax_file,'_blank');
    },
    onApplyTax(data){
      console.log('data-apply-tax',data);
      this.form_data_tax.order_id = data.order_id;
      this.show_tax_form = true;
    },
    closeTaxForm(){
      this.form_data_tax = {
        order_id:'',
        type:1,
        title:'',
        tax_number:'',
        company_address:'',
        phone:'',
        bank_name:'',
        bank_account:'',
      }
      this.show_tax_form = false;
    },
    async saveTax(){
      try{
        const {form_data_tax} = this;
        console.log('form_data_tax',form_data_tax);
        await applyTax(form_data_tax);
        this.$layer.msg('申请开票成功,请耐心等待.');
        this.closeTaxForm();
        this.getOrderList();
      }catch(e){
        console.log('err-save-tax',e);
      }
    },
    showChat(v) {
      this.$refs.chat.showChat(null, v.order_no,v.mtm.design_data.category.image,v.mtm.style_number);
    },
    save() {
      this.form_data_send.logistics_name = this.form_data_send.list.map(i => i.logistics_name).join(',');
      this.form_data_send.logistics_no = this.form_data_send.list.map(i => i.logistics_no).join(',');
      SendFabric(this.form_data_send)
        .then(() => {
          this.$layer.msg(`保存成功`);
          this.is_popup_show = false;
          this.form_data_send = { ...form_data_send };
          return this.getOrderList();
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
    close() {
      this.is_popup_show = false;
      this.form_data_send = { ...form_data_send };
    },
    onSubMeterials(data) {
      console.log('data-sub-meterials',data);
      const {uuid,order_no}  = data;
      this.form_data_send.uuid = uuid;
      this.temp_order_no = order_no;
      // 如果已有逗号分隔数据，拆分为多组
      if (this.form_data_send.logistics_name && this.form_data_send.logistics_name.includes(',')) {
        const names = this.form_data_send.logistics_name.split(',');
        const nos = (this.form_data_send.logistics_no || '').split(',');
            this.form_data_send.list = names.map((name, i) => ({
                  logistics_name: name, logistics_no: nos[i] || '', is_entry: false
                }));
              } else if (this.form_data_send.logistics_name || this.form_data_send.logistics_no) {
                this.form_data_send.list = [{ logistics_name: this.form_data_send.logistics_name, logistics_no: this.form_data_send.logistics_no, is_entry: false }];
              } else {
                this.form_data_send.list = [{ logistics_name: '', logistics_no: '', is_entry: false }];
              }
      this.is_popup_show = true;
    },
    addLogistics() {
      this.form_data_send.list.push({ logistics_name: '', logistics_no: '', is_entry: false });
    },
    removeLogistics(index) {
      if (this.form_data_send.list.length > 1 && !this.form_data_send.list[index].is_entry) {
        this.form_data_send.list.splice(index, 1);
      }
    },
    search() {
      this.getOrderList();
    },
    confirm(uuid) {
      this.$DModal.confirm({
        content: "该订单确认收货么？",
        onOK: () => {
          ConfirmOrder({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.getOrderList();
            });
        },
      });
    },
    cancel(uuid) {
      this.$DModal.confirm({
        content: "该订单确认取消么？",
        onOK: () => {
          CancelOrder({ uuid })
            .then(() => {
              this.$layer.msg(`操作成功`);
            })
            .finally(() => {
              this.getOrderList();
            });
        },
      });
    },
    pay(uuid) {
      this.$router.push({
        name: "WorkBenchCheckout",
        query: { uuid },
      });
      // this.$router.push({name: 'CashDesk', query: {uuid, pay_type: 'wechat'}})
    },
    makeup(uuid) {
      this.$router.push({
        name: "Makeup",
        query: { uuid, pay_type: "wechat" },
      });
    },
    oc(v) {
      return [v.status_text];
    },
    go2detail(uuid) {
      this.$router.push({ name: "OrderDetail", query: { uuid } });
    },
    changePage(page) {
      this.page = page;
      this.getOrderList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.getOrderList();
    },
    change_status(s) {
      this.form_data.status = s;
    },
    onCateClick({ product_category_name }) {
      this.selected_cate_display = product_category_name;
      if (product_category_name === "全部") {
        this.selected_cate = "";
      } else {
        this.selected_cate = product_category_name;
      }
      this.page = 1;
      this.getOrderList();
    },
    onOrderClick({ name, value }) {
      this.curr_order = name;
      this.form_data.order_type = value;
      this.page = 1;
      this.getOrderList();
    },
    onOrderScaleClick({ name, value }) {
      this.curr_order_scale = name;
      this.form_data.order_scale = value;
      this.page = 1;
      this.getOrderList();
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getOrderList() {
      this.order_list = [];
      const params = { ...this.form_data, page: this.page, size: this.size };
      if (this.selected_cate) {
        params.product_category = this.selected_cate;
      }
      return OrderList(params)
        .then((response) => {
          this.order_list = response.data.list;
          this.total = response.data.total;
          if (response.data.cate_list) {
            this.all_cate_list = response.data.cate_list;
          }
          return OrderCount(params);
        })
        .then((response) => {
          for (let code in response.data) {
            this.status_list[code].count = response.data[code];
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-center {
  width: 100%;
  .container {
    padding: 0 70px 0 30px;
    background: white;

    .status-list {
      padding: 20px 0;
      display: flex;
      align-content: flex-start;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      flex-wrap: wrap;
      row-gap: 15px;
      .status-list-box {
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
      }
      .status-item {
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        flex-shrink: 0;
        cursor: pointer;
        padding: 0 15px;
        &.active {
          background: #fa3d5a;
          border-radius: 5px;
          color: white;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      .filter-box {
        display: flex;
        align-items: center;
        column-gap: 10px;
        flex-wrap: wrap;
        row-gap: 10px;
        .filter-item {
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 5px;
          border: 1px solid #f0f0f0;
          border-radius: 30px;
          padding: 5px 12px;
          font-size: 13px;
          cursor: pointer;
          white-space: nowrap;
          .cate-box {
            width: 100%;
            max-height: 300px;
            overflow-y: auto;
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .item {
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &.active, &:hover {
              background: rgba(0,0,0,0.03);
            }
          }
        }
      }
      .search {
        position: relative;
        flex-shrink: 0;
        .icon-search {
          position: absolute;
          top: 15px;
          left: 15px;
          width: 18px;
          height: 18px;
        }
        .input {
          width: 220px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          padding-left: 45px;
          background: #f3f4f6;
          font-size: 13px;
          outline: none;
          border: none;
        }
      }
    }

    .list {
      padding: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        // width: 1500px;
        width: 100%;
        margin: 5px 0;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ebedf2;
        &:first-child{
          border:none;
        }
        cursor: pointer;
        color: #191a1c;
        overflow:hidden;
        .title {
          height: 42px;
          line-height: 42px;
          padding-left: 20px;
          color: #191a1c;
          background: #edeff2;
          border-top-left-radius:10px;
          border-top-right-radius:10px;
          display: flex;
          align-items: center;
          .order-tag {
            display: inline-block;
            padding: 2px 10px;
            border-radius: 4px;
            color: #fff;
            font-size: 12px;
            margin-right: 10px;
            line-height: 1.5;
          }
          .tag-big {
            background: #ff6b35;
          }
          .tag-sample {
            background: #2ecc71;
          }
        }
        .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #f6f7fa;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #e3e3e3;
          &:first-child{
            border:none;
          }
          color: #575859;
          font-size: 14px;
          overflow:hidden;
          .info {
            width: 730px;
          }
          .quantity {
            width: 200px;
          }
          .amount {
            width: 200px;
          }
          .status {
            width: 200px;
          }
          .action {
            width: 200px;
          }
        }
        .content {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          align-items: center;
          .info {
            width: 730px;
            border-right: 1px solid #e3e3e3;
            .sub-info {
              display: flex;
              height: 150px;
              padding: 10px;
              .left {
                display:flex;
                align-items:center;
                .image {
                  width: 110px;
                  height: 110px;
                  object-fit: cover;
                }
              }
              .right {
                text-align: left;
                padding: 10px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                .sub-name {
					width: 100%;
					color: #666;
					font-size: 14px;
                }
				  .sub-no {
					  width: 100%;
					  color: #666;
					  font-size: 14px;
				  }
                .sub-category {
                  width: 100%;
                  color: #666;
                  font-size: 14px;
                }
                .sub-size {
                  width: 100%;
                  color: #666;
                   overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .sub-quantity {
                  width: 100%;
                  color: #666;
                }
              }
            }
          }
          .quantity {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
          }
          .amount {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-weight: bold;
            font-size: 14px;
          }
          .status {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-size: 14px;
            &.unpaid {
              color: #ff4400;
            }
            &.wait_delivery {
              color: #1572b8;
            }
            &.wait_confirm {
              color: #32a410;
            }
            &.cancel {
              color: #666666;
            }
            &.complete {
              color: #666666;
            }
          }
          .action {
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            row-gap: 5px;
            .btn {
              width: 80px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              border-radius: 5px;
              font-size: 14px;
              margin: 0 5px;
              &.btn-pay {
                background: #fa3d5a;
                color: white;
              }
            }
            .btn-customer {
              color: #3c3c3c;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      &.form-group-row {
        flex-wrap: nowrap;
      }
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
        flex-shrink: 0;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly], &[disabled] {
            background: #f5f5f5;
            color: #999;
            cursor: not-allowed;
          }
          &.input-sm {
            width: 180px;
          }
          &:nth-of-type(2) .input-sm {
            width: 220px;
          }
        }
      }
    }

    .btn-add {
      margin: 15px 0 0 100px;
      width: 110px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      color: #666;
      font-size: 13px;
    }
    .btn-delete {
      position: static;
      margin-left: 10px;
      flex-shrink: 0;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fa3d5a;
      cursor: pointer;
      font-size: 13px;
      border: 1px solid #fa3d5a;
      border-radius: 4px;
    }
    .btn-submit {
      margin: 40px auto 0;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

.customer {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
}
</style>
